import React, { useEffect, useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import { useParams } from "react-router";
import NationalityDropdown from "../../UI/NationalityDropdown";

const EmailValidation = ({
  setCanContinue,
  setEmail,
  setPassword,
  setName,
  setCI,
  setNationality,
  email,
  password,
  name,
  ci,
  nationality,
}) => {
  const [invalidEmail, setInvalidEmail] = useState(null);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const handleValidation = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email?.length > 0) {
      if (emailRegex.test(email)) {
        setInvalidEmail(false);
        setEmail(email);
      } else {
        setInvalidEmail(true);
        setEmail(email);
      }
    } else {
      setInvalidEmail(true);
    }
  };

  useEffect(() => {
    if (email && password && name && ci && nationality && !invalidEmail) {
      setCanContinue(true);
    } else {
      setCanContinue(false);
    }
  }, [email, password, name, nationality, ci]);

  return (
    <div className="bg-white shadow-lg rounded-lg p-4 sm:p-6 md:p-8 max-w-4xl mx-auto">
      {/* Header Section */}
      <div className="mb-6">
        <h2 className="text-2xl sm:text-3xl font-bold mb-3 text-gray-800">
          Creá tu cuenta
        </h2>
        <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
          Ingresá tus datos personales para crear tu cuenta y acceder a la gestión de tus citas y datos médicos.
        </p>
      </div>

      {/* Form Section */}
      <form className="flex flex-col space-y-4">
        {/* Name Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nombre Completo <span className="text-red-500">*</span>
          </label>
          <input
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out"
            required
            type="text"
            placeholder="Ej: Juan Pérez"
            onChange={(e) => setName(e.target.value)}
            value={name || ""}
          />
        </div>

        {/* CI Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Cédula de Identidad <span className="text-red-500">*</span>
          </label>
          <input
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out"
            required
            type="text"
            placeholder="Ej: 1234567"
            onChange={(e) => setCI(e.target.value)}
            value={ci || ""}
          />
        </div>

        {/* Nationality Dropdown */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Nacionalidad <span className="text-red-500">*</span>
          </label>
          <NationalityDropdown
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3"
            defaultValue={"Paraguay"}
            currentValueSetter={(e) => setNationality(JSON.parse(e))}
          />
        </div>

        {/* Email Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Correo Electrónico <span className="text-red-500">*</span>
          </label>
          <input
            className={`bg-gray-50 border ${
              invalidEmail ? "border-red-500" : "border-gray-300"
            } text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 transition duration-150 ease-in-out`}
            required
            type="email"
            placeholder="correo@ejemplo.com"
            pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
            title="Dirección de correo electrónico inválida"
            onChange={(e) => handleValidation(e.target.value)}
            value={email || ""}
          />
          {invalidEmail && (
            <p className="text-xs text-red-500 mt-1">
              Por favor, ingresá un correo electrónico válido
            </p>
          )}
        </div>

        {/* Password Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Contraseña <span className="text-red-500">*</span>
          </label>
          <div className="relative">
            <input
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 block w-full p-3 pr-10 transition duration-150 ease-in-out"
              required
              type={isPasswordVisible ? "text" : "password"}
              placeholder="Mínimo 6 caracteres"
              minLength={6}
              onChange={(e) => setPassword(e.target.value)}
              value={password || ""}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="absolute inset-y-0 right-0 flex items-center pr-3 hover:text-gray-700"
              aria-label={isPasswordVisible ? "Ocultar contraseña" : "Mostrar contraseña"}
            >
              {isPasswordVisible ? (
                <EyeSlashIcon
                  className="h-5 w-5 text-gray-500"
                  aria-hidden="true"
                />
              ) : (
                <EyeIcon className="h-5 w-5 text-gray-500" aria-hidden="true" />
              )}
            </button>
          </div>
          <p className="text-xs text-gray-500 mt-1">
            La contraseña debe tener al menos 6 caracteres
          </p>
        </div>
      </form>
    </div>
  );
};

export default EmailValidation;
